// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7730":"dbdb3ba4b9f542b0","9838":"c90a15a36fedc1f5","9841":"fc7ffcc35c6bafad"}[chunkId] + ".js";
};